export function getUniqueCountries(hotels, flights) {
  let countryCodes = hotels?.map((hotel) => hotel?.countryCode);

  if (!countryCodes[0]) {
    let lastFlight = [...flights]?.pop();
    countryCodes = [lastFlight?.arrivalAirportCountry];
  }

  return countryCodes;
}
